module.exports = __webpack_public_path__ + "img/Vector_5.c15ce315.svg";